import { action, makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import ErrorList from '../ErrorList';
import { hasUserData, userDataDescription } from '~/lib/helper/UserDataHelper';

type UserDataOptionProps = {
    userData?: string;
    onChange: (userData?: string) => unknown;
    errors?: string[];
};

@observer
export default class UserDataOption extends React.Component<UserDataOptionProps> {
    @observable
    userDataEnabled = true;

    previousValue? = '';

    constructor(props: UserDataOptionProps) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        runInAction(() => (this.userDataEnabled = hasUserData(this.props.userData)));
    }

    @action
    disableUserData() {
        this.userDataEnabled = false;
        this.previousValue = this.props.userData;
        // An omitted user_data keeps the server's existing value; an empty string clears it.
        this.props.onChange('');
    }

    @action
    enableUserData() {
        this.userDataEnabled = true;
        this.props.onChange(this.previousValue);
    }

    toggleUserData(enable: boolean) {
        if (enable) {
            this.enableUserData();
        } else {
            this.disableUserData();
        }
    }

    render() {
        const { userData, onChange, errors } = this.props;
        return (
            <>
                <p>{userDataDescription}</p>
                <FormGroup check>
                    <Label check>
                        <Input
                            type="checkbox"
                            checked={this.userDataEnabled}
                            onChange={(e) => this.toggleUserData(e.currentTarget.checked)}
                        ></Input>
                        Enable Cloud-init User Data
                    </Label>
                </FormGroup>
                <FormGroup>
                    {this.userDataEnabled && (
                        <Input
                            id="serverSettingUserData"
                            aria-label="Cloud-init user data"
                            className="font-monospace"
                            type="textarea"
                            rows="7"
                            value={userData ?? ''}
                            placeholder=""
                            onChange={(e) => onChange(e.target.value)}
                            invalid={errors && errors.length > 0}
                        />
                    )}
                    <FormFeedback>
                        <ErrorList errors={errors} />
                    </FormFeedback>
                </FormGroup>
            </>
        );
    }
}
